/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A better room ranked by the LLM with a short reason.
 * @export
 * @interface RankedBetterRoom
 */
export interface RankedBetterRoom {
    /**
     * 
     * @type {string}
     * @memberof RankedBetterRoom
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof RankedBetterRoom
     */
    tier: number;
    /**
     * 1-indexed rank, 1 = best.
     * @type {number}
     * @memberof RankedBetterRoom
     */
    rank: number;
    /**
     * One-sentence rationale for why this room is recommended (LLM-generated).
     * @type {string}
     * @memberof RankedBetterRoom
     */
    reason: string;
}

/**
 * Check if a given object implements the RankedBetterRoom interface.
 */
export function instanceOfRankedBetterRoom(value: object): value is RankedBetterRoom {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RankedBetterRoomFromJSON(json: any): RankedBetterRoom {
    return RankedBetterRoomFromJSONTyped(json, false);
}

export function RankedBetterRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankedBetterRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'tier': json['tier'],
        'rank': json['rank'],
        'reason': json['reason'],
    };
}

export function RankedBetterRoomToJSON(json: any): RankedBetterRoom {
    return RankedBetterRoomToJSONTyped(json, false);
}

export function RankedBetterRoomToJSONTyped(value?: RankedBetterRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'tier': value['tier'],
        'rank': value['rank'],
        'reason': value['reason'],
    };
}

